export const FETCH_CHANGESHIFT = 'views/users/FETCH_CHANGESHIFT'